var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.runner
    ? _c("app-browse-to-file-settings", {
        attrs: { state: _vm.state },
        on: {
          close: function ($event) {
            return _vm.close()
          },
          confirm: _vm.printBrowse,
        },
      })
    : _c("app-browse-to-file-progress", {
        attrs: { runner: _vm.runner },
        on: {
          close: function ($event) {
            return _vm.close()
          },
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }